import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { ManageUserModule } from '@/modules/support/manage-user';
import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import { z } from 'zod';

const manageUserSearchSchema = z.object({
  search: z.string().optional(),
  userId: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/support/manage-user')({
  validateSearch: manageUserSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessSupportDashboard } = useAccessControl();
  const matchRoute = useMatchRoute();
  const isTransactionRoute = matchRoute({
    to: '/dashboard/support/manage-user/transaction',
  });

  const isOrderHistoryRoute = matchRoute({
    to: '/dashboard/support/manage-user/order-history',
  });

  const isGameplayHistoryRoute = matchRoute({
    to: '/dashboard/support/manage-user/gameplay-history',
  });
  const isFantasyHistoryRoute = matchRoute({
    to: '/dashboard/support/manage-user/fantasy-history',
  });
  const isAviatorHistoryRoute = matchRoute({
    to: '/dashboard/support/manage-user/aviator-history',
  });

  if (
    isTransactionRoute ||
    isOrderHistoryRoute ||
    isGameplayHistoryRoute ||
    isFantasyHistoryRoute ||
    isAviatorHistoryRoute
  ) {
    return canAccessSupportDashboard ? <Outlet /> : <AccessDenied />;
  }

  return canAccessSupportDashboard ? <ManageUserModule /> : <AccessDenied />;
}
